module.exports = __webpack_public_path__ + "static/media/SE.ea2a67f5.svg";